<template lang="pug">
  app-toolbar(title="Счета на оплату")

    app-toolbar-item-period.ml-12(@select="handlePeriod" :showAll="false") {{ period ? period.text : 'все' }} 

    app-toolbar-item.ml-12.text-lowercase(v-if="isTypesLoaded" label="Тип услуги" all="Все" :items="types" key-name="title" @select="filterByType") {{ selectedType | typeNamed }}

    app-toolbar-item.ml-12(label="Сортировать" :items="sorter" key-name="title" min-width="120" @select="sortBy") {{ currentSort.title }}

    app-dialog-loading(v-model="updating")
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { $_app_moment } from "@/common/AppMoment.js"

import { AppDialogLoading } from '@/components'
import AppStatuses from "@/assets/data/SpecAppStatuses.json"

import moment from 'moment'
moment.locale('ru')

export default {
  components: {
    [AppDialogLoading.name]: AppDialogLoading
  },
  mixins: [ $_app_moment ],
  data() {
    return {
      loading: false,
      currentSort: {title: 'по дате'},
      sorter: [
        {title: 'по дате'},
        {title: 'по сумме'}
      ]
    }
  },

  computed: {
    ...mapState('appreestr', [ 'selectedType', 'period', 'updating', 'selectedSort']),
    ...mapGetters('appreestr', ['types','isTypesLoaded']),
  },

  methods: {
    ...mapMutations('appreestr', [ 'selectType', 'setPeriod', 'selectSort']),

    handlePeriod (item) {
      let load = (this.period.start!=item.start || this.period.end!=item.end)? true : false
      this.setPeriod(item)
      if(load) this.$store.dispatch('appreestr/LOAD_REESTR_PERIOD')
    },

    statusColor(item) {
      if (item.color > 0 && item.color < 4) {
        return AppStatuses.colors[item.color]
      }
      return ''
    },

    filterByType(type) {
      this.selectType(type)
    },

    sortBy(item, index) {
      this.currentSort = item
      this.selectSort(index)
    }
  },

  filters: {
    typeNamed: type => {
      return type != null ? type.title : 'Все'
    },
  },

}
</script>


<style lang="scss" scoped>
  .sud-card-text {
    background: #FFFFFF; 
  }
</style>
